import axios from "axios";
import AES from "@/utils/aes";
import { useSystemConfigStore } from "@/stores/systemConfig";
import { useUserInfoStore } from "@/stores/userInfo";
import { getConfig, urlRegex } from "@/utils/index";
import bus from "@/utils/bus";
import { ElMessage } from "element-plus";
import { md5 } from "js-md5";
import { Base64 } from "js-base64";

const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 60000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config: any) => {
    const systemConfigStore = useSystemConfigStore();
    const userInfoStore = useUserInfoStore();
    let token = userInfoStore.token;

    config.headers.language = "en_US";
    config.headers.systemId = 1;
    config.headers.tenantId = 1;
    config.headers.timezone = "UTC-8";
    config.headers.country = "ALL";
    // 特殊处理
    const skipUrl = ["/aa-sso-api/ext/app/https/appconfig/query?appId=1"];

    if (!skipUrl.includes(config.url) && token) {
      if (!config.url.startsWith("/")) {
        config.url = "/" + config.url;
      }
      if (config.baseURL.endsWith("/")) {
        config.baseURL = config.baseURL.slice(0, -1);
      }
      // console.log('config.baseURL', config.baseURL);
      let uri = urlRegex(config.baseURL) + config.url;
      let token_secret = AES.encrypt(token, getConfig("token_secret_key"));
      let x_secret = AES.encrypt(
        new Date().getTime().toString(),
        getConfig("x_secret_key")
      );
      let sign = Base64.encode(md5(uri + token + getConfig("sign_secret_key")));
      // console.log('sign\n     ', sign, '\nuri     ', uri, '\ntoken  ', token, '\nsign_secret_key  ', getConfig('sign_secret_key')[0].configValue, '\ndecode_sign   ', uri + token + getConfig('sign_secret_key')[0].configValue);

      config.headers.x = x_secret;
      config.headers.uri = uri;
      config.headers.sign = sign;
      config.headers.token = token_secret;
      config.headers.userId = userInfoStore.userId;
    } else {
      config.headers = {
        ...config.headers,
        x: "",
        uri: "",
        userId: 0,
      };
    }
    return config;
  },
  (error) => {
    // do something with request error
    const systemConfigStore = useSystemConfigStore();
    systemConfigStore.removeLoading();
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

let logoutCount = 0;
// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== "C00001" && res.code !== "POP0001") {
      ElMessage({
        type: "error",
        message: res.description,
        duration: 5 * 1000,
      });
    }
    return res;
  },
  async (error) => {
    const systemConfigStore = useSystemConfigStore();
    switch (error?.response?.status) {
      case 400:
        ElMessage({
          type: "error",
          message: error.response.data.description,
          duration: 5 * 1000,
        });
        return Promise.reject(error?.response?.data);
        break;
      case 401:
        if (error?.response?.data?.code == "C00995") {
          if (logoutCount == 0) {
            logoutCount++;
            ElMessage({
              type: "error",
              message: error.response.data.description,
            });
            logoutCount--;
            bus.emit("onLogout");
          }
        }
        break;
      default:
        break;
    }
    systemConfigStore.removeLoading();
    return Promise.reject(error);
  }
);

export default service;
